module.exports = __webpack_public_path__ + "static/media/so.f83c7ff5.svg";